<template>
  <div class="slideshow-container" ref="slideshow">
    <span class="artist">
      <font-awesome-icon :icon="['fab', 'twitch']" />
      {{ submission.user.displayName || submission.user.username }}</span
    >
    <button class="slideshow__close" @click="closeSlideshow">
      <font-awesome-icon icon="window-close" />
    </button>
    <slideshow-progress />
    <div class="nav__left">
      <font-awesome-icon icon="chevron-left" @click="goToPrev" />
    </div>
    <div
      class="artwork"
      :class="[{ grayscale: showGrayscale }, { mirrored: showMirrored }]"
    >
      <img :src="submission.url" alt="" />
      <p v-if="submission.comment" class="artwork__comment">
        {{ submission.comment }}
      </p>
    </div>
    <div class="nav__right" @click="goToNext">
      <font-awesome-icon icon="chevron-right" />
    </div>
  </div>
</template>

<script>
import SlideshowProgress from './SlideshowProgress.vue';

import { mapActions, mapState, mapGetters } from 'vuex';
export default {
  name: 'slideshow',
  components: { SlideshowProgress },
  data: function() {
    return {
      keysDown: [],
      showGrayscale: false,
      showMirrored: false,
    };
  },
  methods: {
    ...mapActions('teacher', ['setArtwork', 'closeSlideshow']),
    goToNext() {
      this.setArtwork(this.nextSubmission);
    },
    goToPrev() {
      this.setArtwork(this.previousSubmission);
    },
    closeHandler() {
      this.closeSlideshow();
    },
    keyUpHandler() {
      this.keysDown = [...[]];
    },
    keyDownHandler(e) {
      this.keysDown.push(e.key);
      switch (e.key) {
        case 'ArrowRight':
          this.goToNext();
          break;
        case 'ArrowLeft':
          this.goToPrev();
          break;
        case 'Escape':
          this.closeSlideshow();
      }

      if (
        (this.keysDown.includes('Meta') || this.keysDown.includes('Control')) &&
        this.keysDown.includes('y')
      ) {
        this.showGrayscale = !this.showGrayscale;
      }

      if (
        (this.keysDown.includes('Meta') || this.keysDown.includes('Control')) &&
        this.keysDown.includes('m')
      ) {
        this.showMirrored = !this.showMirrored;
      }
    },
  },
  mounted() {
    document.addEventListener('keydown', this.keyDownHandler, false);
    document.addEventListener('keyup', this.keyUpHandler, false);

    this.$refs.slideshow.requestFullscreen();
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this.keyDownHandler);
    document.removeEventListener('keyup', this.keyUpHandler);
  },
  computed: {
    ...mapState('teacher', {
      submission: state => state.current,
    }),
    ...mapGetters('teacher', ['nextSubmission', 'previousSubmission']),
  },
};
</script>

<style lang="scss" scoped>
.slideshow-container {
  display: flex;
  width: 100vw;
  height: 100vh;
  position: fixed;
  background: rgba(0, 0, 0, 0.9);
  z-index: 1200;

  .slideshow__close {
    background: transparent;
    position: absolute;
    top: 1rem;
    right: 1rem;
    color: white;
    font-size: 2rem;
    opacity: 0.8;

    &:hover {
      opacity: 1;
    }
  }

  .artist {
    // background: #18181b; // Twitch darkmode background
    position: absolute;
    top: 1rem;
    left: 50%;
    transform: translateX(-50%);
    padding: 1rem;
    font-size: 2rem;
    color: color('twitch', 'light');
    border-radius: 8px;
  }

  .nav__left,
  .nav__right {
    color: white;
    display: flex;
    align-items: center;
    padding: 0 2rem;
    font-size: 48px;
    cursor: pointer;
  }

  .artwork {
    padding: 5rem;
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    &__comment {
      color: rgba(255, 255, 255, 0.9);
      display: flex;
      margin: 1rem 0 0 0;
      flex: 1;
      align-items: center;
      max-width: 724px;
      min-height: 100px;
    }

    &.grayscale {
      img {
        filter: grayscale(100);
      }
    }

    &.mirrored img {
      transform: scaleX(-1);
    }

    img {
      margin-top: 2rem;
      max-width: 100%;
      max-height: 80vh;
      flex: 0 1 auto;
      width: auto;
      align-self: center;
      box-shadow: 0 8px 64px 0 rgba(0, 0, 0, 0.5);
      border-radius: 8px;
      user-select: none;
    }
  }
}
</style>
